import { useCallback, useEffect } from 'react';

export const useClickOutside = (
  ref: React.RefObject<HTMLElement>,
  onClickOutside: () => void,
) => {
  const handleBackdropClick: EventListener = useCallback(
    (event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClickOutside();
        event.preventDefault();
        event.stopPropagation();
      }
    },
    [onClickOutside, ref],
  );

  useEffect(() => {
    document.addEventListener('click', handleBackdropClick);

    return () => document.removeEventListener('click', handleBackdropClick);
  }, [handleBackdropClick]);
};
